import { dismissFlag } from '../../state/domain/flags/actions.tsx';
import { changeSort } from '../../state/domain/view-settings/visualisations/actions.tsx';

const mapDispatchToProps = {
	onDismissFlag: dismissFlag,
	onChangeSort: changeSort,
} as const;

export default mapDispatchToProps;
